import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { defineGlobals } from './defineGlobals';
import { defineCustomElements } from '@tag/tag-components';
import '@tag/tag-components-v3/dist/tag-library-v3/tag-library-v3.css';
import {
  applyPolyfills,
  defineCustomElements as defineCustomElements_v3,
} from '@tag/tag-components-v3/loader';
import { DarkModeContextWrapper } from './darkModeContext';

applyPolyfills().then(() => {
  defineCustomElements_v3();
});
defineCustomElements(window);

ReactDOM.render(
  <React.StrictMode>
    <DarkModeContextWrapper>
      <App />
    </DarkModeContextWrapper>
  </React.StrictMode>,
  document.getElementById('root'),
);
defineGlobals();
